import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The best way to install the PostHog Android library is with a build system like
`}<a parentName="p" {...{
        "href": "https://gradle.org/"
      }}>{`Gradle`}</a>{`. This ensures you can easily upgrade to the latest versions. `}</p>
    <p>{`All you need to do is add the `}<inlineCode parentName="p">{`posthog-android`}</inlineCode>{` module to your App's `}<inlineCode parentName="p">{`build.gradle`}</inlineCode>{` or `}<inlineCode parentName="p">{`build.gradle.kts`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gradle_kotlin",
        "metastring": "file=app/build.gradle",
        "file": "app/build.gradle"
      }}>{`dependencies {
  implementation("com.posthog:posthog-android:3.+")
}
`}</code></pre>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <p>{`The best place to initialize the client is in your `}<inlineCode parentName="p">{`Application`}</inlineCode>{` subclass.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import android.app.Application
import com.posthog.android.PostHogAndroid
import com.posthog.android.PostHogAndroidConfig

class SampleApp : Application() {

    companion object {
        const val POSTHOG_API_KEY = "<ph_project_api_key>"
        // usually 'https://us.i.posthog.com' or 'https://eu.i.posthog.com'
        const val POSTHOG_HOST = "<ph_client_api_host>"
    }

    override fun onCreate() {
        super.onCreate()

        val config = PostHogAndroidConfig(
            apiKey = POSTHOG_API_KEY,
            host = POSTHOG_HOST // TIP: host is optional if you use https://us.i.posthog.com
        )
        PostHogAndroid.setup(this, config)
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      